import { useEffect, useRef } from "react";

const CLIENT_ID = "ca-pub-4043314376774351";

const AD_UNITS = {
  display: { slot: "6522489316", format: "auto" },
  inFeed: {
    slot: "1132315856",
    format: "fluid",
    layoutKey: "-6r+ee+29-24-31",
  },
  inArticle: {
    slot: "1922653346",
    format: "fluid",
    layout: "in-article",
  },
  multiplex: { slot: "7506152514", format: "autorelaxed" },
};

export default function PluseAdSense({ type = "inFeed" }) {
  const adRef = useRef(null);
  const unit = AD_UNITS[type] || AD_UNITS.inFeed;

  useEffect(() => {
    const element = adRef.current;
    if (!element) return;

    let cancelled = false;
    let attempts = 0;
    let timer;

    const initialize = () => {
      if (cancelled || !element.isConnected) return;

      // Wait until the ad has a measurable width.
      if (element.getBoundingClientRect().width < 100) {
        if (attempts++ < 20) timer = setTimeout(initialize, 250);
        return;
      }

      // Never push the same ad element twice.
      if (
        element.dataset.adInitialized === "true" ||
        element.getAttribute("data-adsbygoogle-status")
      ) return;

      const ads = window.adsbygoogle = window.adsbygoogle || [];

      try {
        element.dataset.adInitialized = "true";
        ads.push({});
      } catch (error) {
        delete element.dataset.adInitialized;
        console.error("Pluse AdSense initialization failed:", error);
      }
    };

    // Allow React layout and responsive CSS to settle before requesting.
    timer = setTimeout(initialize, 150);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`pluse-google-ad pluse-google-ad-${type}`}>
      <div className="pluse-google-ad-label">
        Ads help keep <strong>LostDC Network</strong> free and support new features. Thank you!
      </div>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{
          display: "block",
          width: "100%",
          ...(type === "inArticle" ? { textAlign: "center" } : {}),
        }}
        data-ad-client={CLIENT_ID}
        data-ad-slot={unit.slot}
        data-ad-format={unit.format}
        data-full-width-responsive={type === "display" ? "true" : undefined}
        data-ad-layout-key={unit.layoutKey}
        data-ad-layout={unit.layout}
      />
    </div>
  );
}
